// extracted by mini-css-extract-plugin
export var rotate180 = "Icon-module--rotate180--35244";
export var rotate270 = "Icon-module--rotate270--35492";
export var rotate90 = "Icon-module--rotate90--0e690";